import { Store } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgStoreFront = mkIcon(Store);
